import { useSharedRollbar } from 'components/ErrorFallbackComponents/ErrorBoundary';
import { useState } from 'react';
import { fetchNewCheckoutSessionId } from './workshopApi';
export interface GenerateAndGetCheckoutSessionIdParams {
  action: 'CREATE' | 'CREATE_RETREAT';
  owner_id: string;
  shop_product_id: string;
  accommodation_option_id?: string;
  success_url?: string;
  cancel_url?: string;
  success_cancel_page?: 'WEB' | 'MOBILE';
  user_pseudo_id?: string;
  guest_details?: {
    first_name: string;
    last_name: string;
    email?: string;
  }[];
  platform?: 'WEB' | 'IOS' | 'ANDROID';
}

const useGetNewCheckoutSessionId = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const rollbar = useSharedRollbar();

  const generateAndGetCheckoutSessionId = (
    data: GenerateAndGetCheckoutSessionIdParams
  ) => {
    setLoading(true);
    setError(null);
    return fetchNewCheckoutSessionId(data)
      .catch(e => {
        if (rollbar)
          rollbar.error('Failed to generate checkout session ID', {
            error: e,
            data
          });
        setError(e);
        return Promise.reject(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    generateAndGetCheckoutSessionId,
    loading,
    error
  };
};

export default useGetNewCheckoutSessionId;
